import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import css from "./OpenClosedIndicator.module.scss";
import { classNames } from "@greeter/util";

export type OpenClosedIndicatorProps = {
  open?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export function OpenClosedIndicator({
  open,
  style,
  className,
}: OpenClosedIndicatorProps) {
  return (
    <div {...classNames(css.OpenClosedIndicator, className)} style={style}>
      {!open && <IconChevronDown className={css.Chevron} />}
      {open && <IconChevronUp className={css.Chevron} />}
    </div>
  );
}
